import { render } from "./PlusBtn.vue?vue&type=template&id=64957278"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PlusBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64957278"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64957278', __exports__)) {
    api.reload('64957278', __exports__)
  }
  
  module.hot.accept("./PlusBtn.vue?vue&type=template&id=64957278", () => {
    api.rerender('64957278', render)
  })

}


export default __exports__